import React, { useEffect, useState } from 'react'
import { Link } from 'gatsby'
import MenuItemsList from '../components/MenuItemsList'

import CircleButton from './CircleButton'

// Import all product mobile video
import MKV03 from '../assets/video/mobile/mobile_sek2_KV03.mp4'
import MKV04 from '../assets/video/mobile/mobile_sek2_KV04.mp4'
import MKV05 from '../assets/video/mobile/mobile_sek2_KV05.mp4'
import MKV06 from '../assets/video/mobile/mobile_sek2_KV06.mp4'
import MKV07 from '../assets/video/mobile/mobile_sek2_KV07.mp4'
import MKV10 from '../assets/video/mobile/mobile_sek2_KV10.mp4'
import MKV13 from '../assets/video/mobile/mobile_sek2_KV13.mp4'
import MKV17 from '../assets/video/mobile/mobile_sek2_KV17.mp4'

// Import all product tablet video
import TKV03 from '../assets/video/tablet/tablet_sek2_KV03.mp4'
import TKV04 from '../assets/video/tablet/tablet_sek2_KV04.mp4'
import TKV05 from '../assets/video/tablet/tablet_sek2_KV05.mp4'
import TKV06 from '../assets/video/tablet/tablet_sek2_KV06.mp4'
import TKV07 from '../assets/video/tablet/tablet_sek2_KV07.mp4'
import TKV10 from '../assets/video/tablet/tablet_sek2_KV10.mp4'
import TKV13 from '../assets/video/tablet/tablet_sek2_KV13.mp4'
import TKV17 from '../assets/video/tablet/tablet_sek2_KV17.mp4'

// Import all product desktop video
import DKV03 from '../assets/video/desktop/desktop_sek2_KV03.mp4'
import DKV04 from '../assets/video/desktop/desktop_sek2_KV04.mp4'
import DKV05 from '../assets/video/desktop/desktop_sek2_KV05.mp4'
import DKV06 from '../assets/video/desktop/desktop_sek2_KV06.mp4'
import DKV07 from '../assets/video/desktop/desktop_sek2_KV07.mp4'
import DKV10 from '../assets/video/desktop/desktop_sek2_KV10.mp4'
import DKV13 from '../assets/video/desktop/desktop_sek2_KV13.mp4'
import DKV17 from '../assets/video/desktop/desktop_sek2_KV17.mp4'

export const mobileMaxW = '(max-width: 833px)'
export const desktopMinW = '(min-width: 1366px)'

const HomeProducts = ({ id = 'products' }) => {
  const [tabIndex, setTabIndex] = useState(0)
  const [breakpoint, setBreakpoint] = useState('')
  useEffect(() => {
    checkBreakpoint()
    setMutedAttribute()

    const activeProducts = document
      .getElementById('products')
      .querySelectorAll('.activeItem')

    // Load videos after returns
    activeProducts.forEach((activeProduct) => {
      loadVideo(
        activeProduct.dataset.videoli,
        activeProduct.parentElement.parentElement
      )
    })
    countForCircle()

    window.addEventListener('resize', () => {
      checkBreakpoint()
    })
  })

  const checkBreakpoint = () => {
    const desktopBreakpoint = window.matchMedia(desktopMinW)
    const mobileBreakpoint = window.matchMedia(mobileMaxW)
    if (desktopBreakpoint.matches) {
      setBreakpoint('desktop')
    }
    if (mobileBreakpoint.matches) {
      setBreakpoint('mobile')
    }
    if (!mobileBreakpoint.matches && !desktopBreakpoint.matches) {
      setBreakpoint('tablet')
    }
  }

  const setMutedAttribute = () => {
    const allVideo = document.querySelectorAll('.product-video')

    allVideo.forEach((video) => {
      video.setAttribute('muted', '')
    })
  }

  function countForCircle() {
    const productsSection = document.querySelector('#products')
    const tabs = productsSection.querySelectorAll('.tab-heading').length
    const circleCount = productsSection.querySelectorAll('.circleCount')

    circleCount.forEach((circle) => {
      if (tabs < 10) {
        const changeAfter = '0' + tabs
        circle.setAttribute('sumproducts', changeAfter)
      } else circle.setAttribute('sumproducts', tabs)
    })
  }

  function changeCircleValue(index) {
    const productsSection = document.querySelector('#products')
    const products = productsSection.querySelectorAll('.products-list')
    const circleCount = productsSection.querySelectorAll('.circleCount')

    products.forEach((product) => {
      circleCount.forEach((circle) => {
        if (circle.id === product.id) {
          if (index < 10) {
            const changeBefore = '0' + (index + 1)
            circle.setAttribute('whichproduct', changeBefore)
          } else circle.setAttribute('whichproduct', index + 1)
        }
      })
    })
  }

  function productsClick(e, video) {
    // Set new variables: one for current element and one for current element's parent
    const current = e.currentTarget

    const currentParent = current.parentElement

    // Take all items from current element's parent
    const allProducts = currentParent.querySelectorAll('.products-group')

    // If item from current element's parent has active class then remove
    allProducts.forEach((singleProduct) => {
      if (singleProduct.classList.contains('activeItem')) {
        singleProduct.classList.remove('activeItem')
      }
    })

    // Give for clicked element active class
    current.classList.add('activeItem')

    allProducts.forEach((product) => {
      if (
        product.classList.contains('unActiveItem') &&
        !product.classList.contains('activeItem')
      ) {
        if (product.querySelector('.link-text') !== null) {
          let click = product.querySelector('.link-text').dataset.click
          if (click === '1') {
            product.querySelector('.link-text').dataset.click = '0'
          }
        }
      }
    })

    loadVideo(video, current.parentElement.parentElement)
  }

  function loadVideo(clickedItem, container) {
    // loaded means item with active class
    // clickedItem === Clicked (or loaded) DOM LIST element.
    // Container === Parent of the clicked item (or loaded)

    // Take all divs for video
    const productsVideo = document.querySelectorAll('.product-video')

    // Create object with mobile imports, this'll be used for load and set src
    const mobileImportsObject = {
      MKV03: MKV03,
      MKV04: MKV04,
      MKV05: MKV05,
      MKV06: MKV06,
      MKV07: MKV07,
      MKV10: MKV10,
      MKV13: MKV13,
      MKV17: MKV17,
    }

    const tabletImportsObject = {
      TKV03: TKV03,
      TKV04: TKV04,
      TKV05: TKV05,
      TKV06: TKV06,
      TKV07: TKV07,
      TKV10: TKV10,
      TKV13: TKV13,
      TKV17: TKV17,
    }

    const desktopImportsObject = {
      DKV03: DKV03,
      DKV04: DKV04,
      DKV05: DKV05,
      DKV06: DKV06,
      DKV07: DKV07,
      DKV10: DKV10,
      DKV13: DKV13,
      DKV17: DKV17,
    }
    let currentObject = {}

    const mobileBreakpoint = window.matchMedia('(max-width: 833px)')
    const desktopBreakpoint = window.matchMedia('(min-width: 1366px)')

    if (desktopBreakpoint.matches) {
      currentObject = desktopImportsObject
    }
    if (mobileBreakpoint.matches) {
      currentObject = mobileImportsObject
    }
    if (!mobileBreakpoint.matches && !desktopBreakpoint.matches) {
      currentObject = tabletImportsObject
    }

    // Take each element from array
    productsVideo.forEach((productVideo) => {
      if (productVideo.dataset.itemid === container.dataset.itemid) {
        for (const [key, value] of Object.entries(currentObject)) {
          if (
            key === clickedItem &&
            clickedItem !== productVideo.dataset.currentvid
          ) {
            productVideo.style.opacity = '0'
            setTimeout(() => {
              productVideo.setAttribute('data-currentVid', clickedItem)
              productVideo.setAttribute('src', value)
              productVideo.style.opacity = '1'
            }, 200)
          }
        }
      }
    })
  }

  return (
    <div id={id}>
      {/* Code below return desktop section, visible only in lg breakpoint */}
      {breakpoint === 'desktop' && (
        <div className='desktop-section container pr-0 desktop-section lg:h-[860px] lg:block hidden bg-white'>
          <div className='flex h-full'>
            <div className='basis-1/2 pr-[65px] pb-[40px]'>
              {/* Render hedings */}
              <div className='flex items-center gap-[38px] mb-[35px] pt-[90px]'>
                {MenuItemsList.filter(
                  (menuItem) => menuItem.title === 'Products'
                ).map((menuItem) => {
                  const returnDesktop = menuItem.submenu.map(
                    (submenu, index) => {
                      return (
                        <h2
                          key={index}
                          className={`${
                            index === 0 ? 'headingActive' : ''
                          } tab-heading text-2xl text-gray-300 text-center cursor-pointer hover:text-orange transition-all duration-200 ease-in-out`}
                          role='presentation'
                          data-aos='fade-up'
                          data-aos-easing='ease'
                          data-aos-delay={index * 200}
                          onClick={(e) => {
                            setTabIndex(index)
                            changeCircleValue(index)

                            const dots = document
                              .getElementById(id)
                              .querySelectorAll('.dot-desktop')
                            const tabsHeading = document
                              .getElementById(id)
                              .querySelectorAll('.tab-heading')
                            dots.forEach((dot) => {
                              if (dot.classList.contains('dotActive')) {
                                dot.classList.remove('dotActive')
                              }
                            })

                            tabsHeading.forEach((tabHeading) => {
                              if (
                                tabHeading.classList.contains('headingActive')
                              ) {
                                tabHeading.classList.remove('headingActive')
                              }
                            })
                            e.currentTarget.classList.add('headingActive')
                            dots[index].classList.add('dotActive')
                          }}
                        >
                          {submenu.title}
                        </h2>
                      )
                    }
                  )
                  return returnDesktop
                })}
              </div>
              {/* Render dots */}
              <div className='flex items-center gap-[12px] mb-[50px]'>
                {MenuItemsList.filter(
                  (menuItem) => menuItem.title === 'Products'
                ).map((menuItem) => {
                  const renderDots = menuItem.submenu.map((submenu, index) => {
                    return (
                      <span
                        role='presentation'
                        key={index}
                        className={`${
                          index === 0 ? 'dotActive' : ''
                        } bg-gray-300 rounded-full w-[6px] h-[6px] dot-desktop block cursor-pointer`}
                        onClick={(e) => {
                          setTabIndex(index)
                          changeCircleValue(index)

                          const dots = document
                            .getElementById(id)
                            .querySelectorAll('.dot-desktop')
                          const tabsHeading = document
                            .getElementById(id)
                            .querySelectorAll('.tab-heading')

                          dots.forEach((dot) => {
                            if (dot.classList.contains('dotActive')) {
                              dot.classList.remove('dotActive')
                            }
                          })
                          tabsHeading.forEach((tabHeading) => {
                            if (
                              tabHeading.classList.contains('headingActive')
                            ) {
                              tabHeading.classList.remove('headingActive')
                            }
                            e.currentTarget.classList.add('dotActive')
                            tabsHeading[index].classList.add('headingActive')
                          })
                        }}
                      ></span>
                    )
                  })
                  return renderDots
                })}
                <div className='ml-[4px] h-[1px] w-full bg-gray-200'></div>
              </div>
              {/* Render category and product list description */}
              <div className='flex flex-col'>
                {MenuItemsList.filter(
                  (menuItem) => menuItem.title === 'Products'
                ).map((menuItem) => {
                  const renderContent = menuItem.submenu.map(
                    (submenu, index) => {
                      return (
                        <div
                          key={index}
                          hidden={tabIndex !== index}
                          className='text-black-100'
                        >
                          <p
                            className='text-lg max-w-[385px] mb-[130px]'
                            data-aos='fade-up'
                            data-aos-easing='ease'
                          >
                            {submenu.description}
                          </p>
                          <div data-itemid={index}>
                            <ul
                              id={index}
                              className='products-list group flex flex-col gap-[30px]'
                              data-aos='fade-up'
                              data-aos-easing='ease'
                            >
                              {submenu.submenu.map((product, index) => {
                                return (
                                  <li
                                    key={index}
                                    role='presentation'
                                    className={`${
                                      index === 0 ? 'activeItem' : ' '
                                    } unActiveDItem products-group group flex items-center gap-[24px] text-gray-200 cursor-pointer`}
                                    data-videoli={product.videoD}
                                    onMouseEnter={(e) => {
                                      productsClick(e, product.videoD)
                                    }}
                                  >
                                    <CircleButton
                                      classList='flex'
                                      url={product.url}
                                    />
                                    <div className='flex flex-col '>
                                      <Link
                                        to={product.url}
                                        className='no-underline'
                                      >
                                        <p className='group-[.activeItem]:text-black-100 text-4xl cursor-pointer'>
                                          {product.title}
                                        </p>
                                        <span className='text-base cursor-pointer'>
                                          {product.status}
                                        </span>
                                      </Link>
                                      <p className='max-w-[360px] group-[.activeItem]:text-black-100 mt-[15px] text-sm text-gray-300'>
                                        {product.description}
                                      </p>
                                    </div>
                                  </li>
                                )
                              })}
                            </ul>
                          </div>
                        </div>
                      )
                    }
                  )
                  return renderContent
                })}
              </div>
            </div>
            {/* Render place for vidoes */}
            <div className='basis-1/2 video-desktop'>
              {MenuItemsList.filter(
                (menuItem) => menuItem.title === 'Products'
              ).map((menuItem) => {
                const returnVideo = menuItem.submenu.map((submenu, index) => {
                  return (
                    <div
                      key={index}
                      className='w-full min-h-[860px] h-full relative'
                      hidden={tabIndex !== index}
                    >
                      <div
                        id={index}
                        className='circleCount flex items-center justify-center absolute top-[30px] right-[30px] w-[80px] h-[80px] rounded-full p-[15px] z-10 bg-black-100 text-gray-300'
                        whichproduct='01'
                        sumproducts='00'
                      >
                        <div
                          className='w-[50px] h-[1px] bg-[#434343]'
                          style={{
                            transform:
                              'matrix(-0.71, 0.71, -0.71, -0.71, 0, 0)',
                          }}
                        ></div>
                      </div>
                      <video
                        preload='yes'
                        loop
                        playsInline
                        autoPlay
                        muted
                        disableRemotePlayback
                        className='product-video w-full h-full object-cover relative -z-0 opacity-1 duration-200 transition-all ease-in-out'
                        data-itemid={index}
                        src=''
                        type='video/mp4'
                      />
                    </div>
                  )
                })
                return returnVideo
              })}
            </div>
          </div>
        </div>
      )}

      {/* Code below return tablet section after tailwind lg breakpoint, section will be hidden */}
      {breakpoint === 'tablet' && (
        <div className='tablet-section lg:hidden md:block bg-white pt-[40px] hidden'>
          <div className='flex flex-col'>
            <div className='flex gap-[64px] pb-[40px] container'>
              {MenuItemsList.filter(
                (menuItem) => menuItem.title === 'Products'
              ).map((menuItem) => {
                const renderTD = menuItem.submenu.map((submenu, index) => {
                  return (
                    <h2
                      key={index}
                      role='presentation'
                      className={`${
                        index === 0 ? 'headingActive' : ''
                      } tab-heading text-2xl text-gray-300 cursor-pointer`}
                      onClick={(e) => {
                        setTabIndex(index)
                        changeCircleValue(index)

                        const dots = document
                          .getElementById(id)
                          .querySelectorAll('.dot')
                        const tabsHeading = document
                          .getElementById(id)
                          .querySelectorAll('.tab-heading')

                        dots.forEach((dot) => {
                          if (dot.classList.contains('dotActive')) {
                            dot.classList.remove('dotActive')
                          }
                        })
                        tabsHeading.forEach((tabHeading) => {
                          if (tabHeading.classList.contains('headingActive')) {
                            tabHeading.classList.remove('headingActive')
                          }
                        })
                        e.currentTarget.classList.add('headingActive')
                        dots[index].classList.add('dotActive')
                      }}
                    >
                      {submenu.title}
                    </h2>
                  )
                })
                return renderTD
              })}
            </div>
            <div className='flex items-center gap-[12px] pb-[40px] container'>
              {MenuItemsList.filter(
                (menuItem) => menuItem.title === 'Products'
              ).map((menuItem) => {
                const renderDots = menuItem.submenu.map((submenu, index) => {
                  return (
                    <span
                      role='presentation'
                      key={index}
                      className={`${
                        index === 0 ? 'dotActive' : ''
                      } bg-gray-300 rounded-full w-[6px] h-[6px] dot block cursor-pointer`}
                      onClick={(e) => {
                        setTabIndex(index)
                        changeCircleValue(index)

                        const dots = document
                          .getElementById(id)
                          .querySelectorAll('.dot')
                        const tabsHeading = document
                          .getElementById(id)
                          .querySelectorAll('.tab-heading')

                        dots.forEach((dot) => {
                          if (dot.classList.contains('dotActive')) {
                            dot.classList.remove('dotActive')
                          }
                        })
                        tabsHeading.forEach((tabHeading) => {
                          if (tabHeading.classList.contains('headingActive')) {
                            tabHeading.classList.remove('headingActive')
                          }
                          e.currentTarget.classList.add('dotActive')
                          tabsHeading[index].classList.add('headingActive')
                        })
                      }}
                    ></span>
                  )
                })
                return renderDots
              })}
              <div className='ml-[4px] h-[1px] w-full bg-gray-200'></div>
            </div>
            {MenuItemsList.filter(
              (menuItem) => menuItem.title === 'Products'
            ).map((menuItem) => {
              const renderContent = menuItem.submenu.map((submenu, index) => {
                return (
                  <div
                    key={index}
                    hidden={tabIndex !== index}
                    className='text-black-100'
                  >
                    <p className='container mx-0 text-lg max-w-[385px] mb-[130px]'>
                      {submenu.description}
                    </p>
                    <div className='container' data-itemid={index}>
                      <ul
                        id={index}
                        className='products-list group flex flex-col gap-[30px] pb-[130px]'
                      >
                        {submenu.submenu.map((product, index) => {
                          return (
                            <li
                              key={index}
                              role='presentation'
                              className={`${
                                index === 0 ? 'activeItem' : ' '
                              } cursor-pointer unActiveItem products-group group flex items-center gap-[24px] text-2xl text-gray-200`}
                              data-videoli={product.videoT}
                              onClick={(e) => {
                                productsClick(e, product.videoT)
                              }}
                            >
                              <CircleButton
                                url={product.url}
                                classList='flex'
                              />
                              <div className='flex flex-col '>
                                <Link
                                  to={product.url}
                                  className='no-underline link-text'
                                  data-click='0'
                                  onClick={(e) => {
                                    if (e.currentTarget.dataset.click === '0') {
                                      e.preventDefault()
                                      e.currentTarget.dataset.click = '1'
                                    } else {
                                      e.currentTarget.dataset.click = '0'
                                      return true
                                    }
                                  }}
                                >
                                  <p className='group-[.activeItem]:text-black-100 cursor-pointer'>
                                    {product.title}
                                  </p>

                                  <span className='text-base cursor-pointer'>
                                    {product.status}
                                  </span>

                                  <p className='max-w-[360px] group-[.activeItem]:text-black-100 mt-[15px] overflow-hidden text-sm text-gray-300'>
                                    {product.description}
                                  </p>
                                </Link>
                              </div>
                            </li>
                          )
                        })}
                      </ul>
                    </div>
                    <div className='relative h-[470px] overflow-hidden'>
                      <div
                        id={index}
                        className='circleCount flex items-center justify-center absolute top-[24px] right-[24px] w-[80px] h-[80px] rounded-full p-[15px] z-10 bg-black-100 text-gray-300'
                        whichproduct='01'
                        sumproducts='00'
                      >
                        <div
                          className='w-[50px] h-[1px] bg-[#434343]'
                          style={{
                            transform:
                              'matrix(-0.71, 0.71, -0.71, -0.71, 0, 0)',
                          }}
                        ></div>
                      </div>
                      <video
                        preload='yes'
                        loop
                        playsInline
                        autoPlay
                        muted
                        disableRemotePlayback
                        className='product-video w-full h-full object-cover relative -z-0 opacity-1 duration-200 transition-all ease-in-out'
                        data-itemid={index}
                        src=''
                        type='video/mp4'
                      />
                    </div>
                  </div>
                )
              })
              return renderContent
            })}
          </div>
        </div>
      )}

      {/* Code below return mobile section after tailwind md breakpoint, section will be hidden */}
      {breakpoint === 'mobile' && (
        <div className='mobile-section'>
          {MenuItemsList.filter(
            (menuItem) => menuItem.title === 'Products'
          ).map((menuItem) => {
            const renderProducts = menuItem.submenu.map((submenu, index) => {
              return (
                <div key={index} className='md:hidden'>
                  <div
                    className='container pt-[50px] bg-gradient-to-b from-white to-[#F0F0F0]'
                    data-itemid={index}
                  >
                    <h2 className='text-3xl'>{submenu.title}</h2>
                    <p className='mt-[32px] mb-[75px] '>
                      {submenu.description}
                    </p>
                    <ul className='group flex flex-col gap-[30px] pb-[45px] overflow-hidden'>
                      {submenu.submenu.map((product, index) => {
                        return (
                          <li
                            key={index}
                            role='presentation'
                            className={`${
                              index === 0 ? 'activeItem' : ' '
                            } unActiveItem products-group group flex items-center gap-[24px] text-2xl text-gray-200`}
                            data-videoli={product.videoM}
                            onClick={(e) => {
                              productsClick(e, product.videoM)
                            }}
                          >
                            <CircleButton
                              url={product.url}
                              classList='flex ml-[5px]'
                            />
                            <div className='flex flex-col '>
                              <Link
                                to={product.url}
                                className='no-underline link-text'
                                data-click='0'
                                onClick={(e) => {
                                  if (e.currentTarget.dataset.click === '0') {
                                    e.preventDefault()
                                    e.currentTarget.dataset.click = '1'
                                  } else {
                                    e.currentTarget.dataset.click = '0'
                                    return true
                                  }
                                }}
                              >
                                <p className='group-[.activeItem]:text-black-100 cursor-pointer'>
                                  {product.title}
                                </p>
                                <span className='text-base cursor-pointer'>
                                  {product.status}
                                </span>
                                <p className='group-[.activeItem]:mt-[15px] group-[.activeItem]:max-h-full max-h-0 overflow-hidden text-sm text-black-100'>
                                  {product.description}
                                </p>
                              </Link>
                            </div>
                          </li>
                        )
                      })}
                    </ul>
                  </div>
                  <video
                    preload='yes'
                    loop
                    playsInline
                    autoPlay
                    muted
                    disableRemotePlayback
                    className='product-video w-full opacity-1 duration-200 transition-all ease-in-out scale-[1.02]'
                    data-itemid={index}
                    src=''
                    type='video/mp4'
                  />
                </div>
              )
            })
            return renderProducts
          })}
        </div>
      )}
    </div>
  )
}

export default HomeProducts
